import { Type } from 'typebox';
import { Value } from 'typebox/value';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { getBlobFilename } from '../../utils/get-blob-filename.js';
export const AttachmentStatuses = {
    local: 'local',
    processing: 'processing',
    ready: 'ready',
    unknown: 'unknown'
};
export const AttachmentStatus = Type.Union([
    Type.Literal(AttachmentStatuses.local),
    Type.Literal(AttachmentStatuses.processing),
    Type.Literal(AttachmentStatuses.ready),
    Type.Literal(AttachmentStatuses.unknown)
]);
export const AttachmentStatusCodec = createFallbackStringEnumCodec(AttachmentStatuses, AttachmentStatuses.unknown);
const AttachmentSchema = Type.Object({
    key: Type.Optional(Type.String({ minLength: 1 })),
    uuid: Type.String({ minLength: 1 }),
    originUuid: Type.Optional(Type.String({ minLength: 1 })),
    originKey: Type.Optional(Type.String({ minLength: 1 })),
    filename: Type.Optional(Type.String({ minLength: 1 })),
    mimeType: Type.String({ minLength: 1 }),
    width: Type.Optional(Type.Integer()),
    height: Type.Optional(Type.Integer()),
    duration: Type.Optional(Type.Integer()),
    status: AttachmentStatusCodec,
    language: Type.Optional(Type.String({ minLength: 1 })),
    mediaId: Type.Optional(Type.String({ minLength: 1 })),
    externalId: Type.Optional(Type.String({ minLength: 1 })),
    file: Type.Optional(Type.Unknown())
});
export const Attachment = Type.Codec(AttachmentSchema)
    .Decode((value) => value)
    .Encode((value) => ({
    key: value.key,
    uuid: value.uuid,
    originUuid: value.originUuid,
    filename: value.filename ?? getBlobFilename(value.file),
    mimeType: value.mimeType,
    width: value.width,
    height: value.height,
    duration: value.duration,
    status: Value.Decode(AttachmentStatusCodec, value.status),
    language: value.language,
    mediaId: value.mediaId,
    externalId: value.externalId
}));
